"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FullScreenProvider = void 0;

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.object.define-property");

var _isFunction2 = _interopRequireDefault(require("lodash/isFunction"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = require("react");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var FullScreenProvider =
/*#__PURE__*/
function (_Component) {
  _inherits(FullScreenProvider, _Component);

  function FullScreenProvider() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, FullScreenProvider);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(FullScreenProvider)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      slideIndex: 0,
      viewerIsOpen: false
    });

    _defineProperty(_assertThisInitialized(_this), "openViewer", function (index) {
      var body = document.getElementsByTagName("BODY")[0];
      body.setAttribute("style", "overflow: hidden;");

      if (_this.props.onSlideshowStateChange) {
        _this.slideshowStateChange();
      }

      _this.setState({
        viewerIsOpen: true,
        slideIndex: index
      });
    });

    _defineProperty(_assertThisInitialized(_this), "closeViewer", function () {
      var body = document.getElementsByTagName("BODY")[0];
      body.setAttribute("style", "overflow: scroll;");

      if (_this.props.onSlideshowStateChange) {
        _this.slideshowStateChange();
      }

      _this.setState({
        viewerIsOpen: false,
        slideIndex: 0 // go to beginning on close

      });
    });

    _defineProperty(_assertThisInitialized(_this), "slideshowStateChange", function () {
      return _this.props.onSlideshowStateChange(_this.state.viewerIsOpen);
    });

    return _this;
  }

  _createClass(FullScreenProvider, [{
    key: "getChildContext",
    value: function getChildContext() {
      return {
        closeViewer: this.closeViewer,
        onViewFullscreen: this.openViewer,
        openViewer: this.openViewer,
        slideIndex: this.state.slideIndex,
        viewerIsOpen: this.state.viewerIsOpen
      };
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      var _this$state = this.state,
          slideIndex = _this$state.slideIndex,
          viewerIsOpen = _this$state.viewerIsOpen;

      if ((0, _isFunction2.default)(children)) {
        return children({
          closeViewer: this.closeViewer,
          onViewFullscreen: this.openViewer,
          openViewer: this.openViewer,
          slideIndex: slideIndex,
          viewerIsOpen: viewerIsOpen
        });
      } else {
        return children;
      }
    }
  }]);

  return FullScreenProvider;
}(_react.Component);

exports.FullScreenProvider = FullScreenProvider;

_defineProperty(FullScreenProvider, "childContextTypes", {
  closeViewer: _propTypes.default.func.isRequired,
  onViewFullscreen: _propTypes.default.func.isRequired,
  openViewer: _propTypes.default.func.isRequired,
  slideIndex: _propTypes.default.number.isRequired,
  viewerIsOpen: _propTypes.default.bool.isRequired
});
//# sourceMappingURL=FullScreenProvider.js.map